var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-basic',{attrs:{"action":_vm.action,"caption":"習慣を始める","icon":"list"}})}
var staticRenderFns = []

export { render, staticRenderFns }